/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import PropTypes from 'prop-types';
import { MantineProvider, createTheme } from '@mantine/core';
import '@mantine/core/styles.css';

import ErrorBoundary from './ErrorBoundary';
import './layout.module.css';
import { AppProvider, AppContext } from './provider';


const LayoutHOC = ({ theme }) => {
  const th = createTheme(theme)
  return {
    theme: th,
    AppContext,
    Layout: ({ children }) => (
      <AppProvider>
        <ErrorBoundary>
          <MantineProvider theme={theme} forceColorScheme="light">
            {children}
          </MantineProvider>
        </ErrorBoundary>
      </AppProvider>
    ),
  }
}

LayoutHOC.propTypes = {
  children: PropTypes.node.isRequired,
};

export default LayoutHOC;
